import { KeywordItemContainer } from './styled';

interface KeywordItemIProps {
  value: string;
}

const KeywordItem = ({ value }: KeywordItemIProps) => {
  return <KeywordItemContainer>{value}</KeywordItemContainer>;
};

export default KeywordItem;
